import { Post } from 'lib/_types'

import Avatar from 'components/Avatar'
import PostCall from 'components/Post/PostCall'

import './style.scss'

const CallPostList = ({
  calls = [],
  itemsPerRow = 1,
}: {
  calls?: Post[]
  itemsPerRow?: 1 | 2 | 3 | 4
}) => {
  return (
    <div className={`CallPostList CallPostList--item-per-row-${itemsPerRow}`}>
      {calls.map((call) => (
        <div className="CallPostList__item" key={call?.id}>
          <Avatar className="CallPostList__item__avatar" user={call?.user} />

          <div className="CallPostList__item__owner-detail">
            <div className="CallPostList__item__owner-detail__name">
              {call?.user?.nickname ?? '-'}
            </div>

            <div className="CallPostList__item__owner-detail__post">
              {call?.text}
            </div>
          </div>

          <div className="CallPostList__item__call">
            <PostCall post={call} />
          </div>
        </div>
      ))}
    </div>
  )
}

export default CallPostList
